import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, DialogTitle, Modal, ModalClose, ModalDialog, ModalOverflow, Stack, Typography } from '@mui/joy';
import { authenticatedFileRequest, isProtectedApi, openEventFile, parsedFileUrl, resolveFileUrl } from '../../utils/secureEventFiles';

function FileRows({ files, busy, action }) {
  return <Stack spacing={1}>{files.map((file, index) => <Box key={file.id || file.link || index}
    sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'space-between', p: 1.2,
      borderRadius: 10, bgcolor: 'background.level1', flexWrap: 'wrap' }}>
    <Box sx={{ minWidth: 0, flex: '1 1 120px' }}><Typography level="body-sm" sx={{ overflowWrap: 'anywhere' }}>{file.name || 'Файл'}</Typography>
      {Number(file.size) > 0 && <Typography level="body-xs">{(Number(file.size) / 1024).toFixed(1)} КБ</Typography>}</Box>
    <Stack direction="row" spacing={0.5}>
      <Button size="sm" variant="plain" disabled={busy || !resolveFileUrl(file)} onClick={() => action(file, false)}>Открыть</Button>
      <Button size="sm" variant="plain" disabled={busy || !resolveFileUrl(file)} onClick={() => action(file, true)}>Скачать</Button>
    </Stack>
  </Box>)}</Stack>;
}
export default function SecureInputFiles({ files = [], folderUrl, loading }) {
  const [error, setError] = useState(''), [busy, setBusy] = useState(false);
  const [folderOpen, setFolderOpen] = useState(false), [folderFiles, setFolderFiles] = useState([]);
  useEffect(() => { setError(''); setFolderOpen(false); setFolderFiles([]); }, [folderUrl, files]);
  const action = async (file, download) => {
    if (busy) return;
    setError(''); setBusy(true);
    try { await openEventFile(file, download); } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  const openFolder = async () => {
    if (busy) return;
    setError('');
    try {
      const url = parsedFileUrl(folderUrl);
      if (!isProtectedApi(url.href)) { window.open(url.href, '_blank', 'noopener,noreferrer'); return; }
      // Protected folder endpoints must be fetched with Bearer, not navigated to.
      setFolderFiles(files); setFolderOpen(true);
      // The input-files response already contains this folder's file list.
      // Show it directly rather than navigating to a protected API/HTML page.
      if (files.length) return;
      setBusy(true);
      const response = await authenticatedFileRequest(url.href);
      const body = await response.json();
      const list = Array.isArray(body.files) ? body.files : Array.isArray(body.items) ? body.items : null;
      if (!list) throw new Error('Не удалось прочитать список файлов папки. Обратитесь к менеджеру.');
      setFolderFiles(list.filter(f => f.kind !== 'folder'));
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <Box sx={{ px: 2, py: 1.5 }}>
    {error && <Alert color="danger" role="alert" sx={{ mb: 1 }}>{error}</Alert>}
    {loading ? <Stack direction="row" spacing={1}><CircularProgress size="sm" /><Typography>Загружаем файлы…</Typography></Stack>
      : files.length ? <FileRows files={files} busy={busy} action={action} />
      : <Typography level="body-sm">Файлы не прикреплены</Typography>}
    {!loading && folderUrl && <Button fullWidth variant="soft" loading={busy} onClick={openFolder}
      sx={{ mt: 1, textAlign: 'left', whiteSpace: 'normal' }}>Открыть папку с вводными данными</Button>}
    <Modal open={folderOpen} onClose={() => setFolderOpen(false)}><ModalOverflow><ModalDialog sx={{ maxWidth: 640, width: 'calc(100% - 32px)' }}>
      <ModalClose /><DialogTitle>Вводные данные</DialogTitle>
      {error && <Alert color="danger" role="alert">{error}</Alert>}
      {busy && <CircularProgress size="sm" />}
      <FileRows files={folderFiles} busy={busy} action={action} />
      {!busy && !folderFiles.length && <Typography>В этой папке нет файлов.</Typography>}
    </ModalDialog></ModalOverflow></Modal>
  </Box>;
}
